import FundOpportunity from '../../../models/FundOpportunity';
import { FundOpportunityAdminState } from './types';

export function readHighlightParams(): {
  highlightedInvestorId?: string;
  highlightedContactId?: string;
} {
  const urlParams = new URLSearchParams(window.location.search);
  const investorId = urlParams.get('investorId');
  const contactId = urlParams.get('contactId');
  return {
    highlightedInvestorId: investorId || undefined,
    highlightedContactId: contactId || undefined,
  };
}

export function buildInitialState(fundOpportunity: FundOpportunity): FundOpportunityAdminState {
  const { highlightedInvestorId, highlightedContactId } = readHighlightParams();

  return {
    loaded: false,
    loading: true,
    highlightedInvestorId,
    highlightedContactId,
    hasScrolledToHighlight: false,
    formData: {
      name: fundOpportunity?.name,
      fundSize: fundOpportunity?.fundSize,
      fundDuration: fundOpportunity?.fundDuration,
      interest: fundOpportunity?.interest,
      lga: fundOpportunity?.lga,
      returnOnInvestment: fundOpportunity?.returnOnInvestment,
      siteArea: fundOpportunity?.siteArea,
      summaryTitle: fundOpportunity?.summaryTitle || null,
      currentValuation: fundOpportunity?.currentValuation ?? null,
      seniorDebtLvr: fundOpportunity?.seniorDebtLvr ?? null,
      security: fundOpportunity?.security || '',
      capitalType: fundOpportunity?.capitalType || '',
      sector: fundOpportunity?.sector || [],
      interestType: fundOpportunity?.interestType || '',
      facilityLimit: fundOpportunity?.facilityLimit ?? null,
      closeDate: fundOpportunity?.closeDate ?? null,
      country: fundOpportunity?.country ?? null,
      state: fundOpportunity?.state ?? null,
      excludeFromCustodian: fundOpportunity?.excludeFromCustodian ?? false,
    },
    addresses: fundOpportunity?.addresses || [],
    isSubmitting: false,
    toastMessage: null,
    toastType: null,
    investorFilter: '',
    cloneModalOpen: false,
    cloneSubmitting: false,
    fundStatusWorkflow: {
      fundStatusConfirmModalOpen: false,
    },
  };
}
